import type { TPageTranslations } from '@crehana/i18n';

import { ATS_PUBLIC_CANDIDATE_FORM } from './constants';
import type { TKeys } from './types';

export const en: TPageTranslations<TKeys, typeof ATS_PUBLIC_CANDIDATE_FORM> = {
  [ATS_PUBLIC_CANDIDATE_FORM]: {
    BANNER_PREVIEW_FORM:
      'This preview form is only informative, so it does not allow uploading files or sending it.',
    // Not found status
    CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND: 'Form not found',
    CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND:
      'Please try again in a few minutes',
    // Closed status
    CANDIDATE_FORM_STATUS_TITLE_CLOSED: 'The application period has ended',
    CANDIDATE_FORM_STATUS_SUBTITLE_CLOSED: 'Thanks for your interest!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_CLOSED:
      'We will be posting new job opportunities very soon.',
    // Success status
    CANDIDATE_FORM_STATUS_TITLE_SUCCESS: 'We have received your application!',
    CANDIDATE_FORM_STATUS_SUBTITLE_SUCCESS:
      'Thanks for your interest in working with us!',
    CANDIDATE_FORM_STATUS_DESCRIPTION_SUCCESS:
      'We will contact you soon about the status of your application.',
    // Error page
    ERROR_PAGE_TITLE_CANDIDATE_FORM: 'An error occurred',
    ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM:
      'Click the button to try loading again.',
    RETRY: 'Retry',
  },
};
